import config from './common.js';
import notice from './notice.js';
import http from './http.js';
import { reject } from 'lodash';
let units = {
  // 去除输入的空格
  trim(value) {
    return value.trim();
  },
  // 删除对象空的属性
  delNull(params) {
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        if (params[key] === '' || params[key] === null) {
          delete params[key];
        }
      }
    }
  },
  install(Vue) {
    Vue.prototype.dispatch = this.dispath;
  },
  //递归查找指定父组件，emit对应方法
  dispath(componentName, name) {
    let parent = this.$parent;
    while (parent) {
      if (parent.$options.name === componentName) {
        break;
      } else {
        parent = parent.$parent;
      }
    }
    if (parent) {
      if (name) {
        parent.$emit(name);
      }
    }
    return parent;
  },
  //新版凤栖云服
  isFqyf: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/fqyf/i) == 'fqyf') {
      return true;
    } else {
      return false;
    }
  },
  hasLogin: function(data) {
    var user = data || sessionStorage.WTS_USER_3 || {};
    if (user.id) {
      return true;
    }
    return false;
  },
  goLogin: function() {
    sessionStorage.currentActiveMenu = '';
    let url = '';
    if (localStorage.orgCode) {
      url = '/' + localStorage.orgCode + '/login';
      localStorage.removeItem('localStorage');
    } else {
      url = '/login';
    }
    try {
      if (window.parent?.document.getElementById('iframe')) {
        window.parent.location.replace(url);
      } else {
        location.replace(url);
      }
    } catch (error) {
      console.log(error);
      location.replace(url);
    }
  },
  // 客服电话
  kfTell() {
    location.href = 'tel://400-9955-788';
  },
  // 客户链接
  toService() {
    location.href =
      'https://webpage.qidian.qq.com/2/chat/h5/index.html?linkType=1&env=ol&kfuin=2852150563&fid=162&key=3635f50f03b5a57b7dbb7656c9868ee1&cate=7&type=10&ftype=1&_type=wpa&qidian=true&translateSwitch=0&roleValue=1&roleData=69';
  },
  channerRouter(e) {
    let channel = config.channel;
    return e + '_' + channel;
  },
  initTree(data, dataItem, idName) {
    if (dataItem[idName] == 0) {
      data.push(dataItem);
    }
    data.forEach(item => {
      if (item.id == dataItem[idName]) {
        if (!item.children) item.children = [];
        item.children.push(dataItem);
      } else if (item.children && item.children.length > 0) {
        this.initTree(item.children, dataItem, idName);
      }
    });
  },
  notCloseModal(_this) {
    //iview表单提交按钮默认会关闭弹窗，表单提交验证需要调用次方法阻止关闭
    _this.$root.$children[0].modalLoading = false;
    _this.$nextTick(() => {
      _this.$root.$children[0].modalLoading = true;
    });
  },
  downloadFile(url, params = {}, type = 'GET', fileName, apiPermissionCode, showLoading = true) {
    showLoading && notice.showLoading('正在下载文件，请稍等片刻');
    return http({
      type: type,
      forced: true,
      responseType: 'blob',
      All: true,
      url: url,
      apiPermissionCode,
      data: params
    })
      .then(res => {
        if (res.headers['content-type'].includes('json')) {
          // 此处拿到的data才是blob
          const { data } = res;
          const reader = new FileReader();
          reader.onload = () => {
            const { result } = reader;
            const errorInfos = JSON.parse(result);
            const { msg } = errorInfos;
            notice.error(msg);
          };
          reader.onerror = err => {
            reject(err);
          };
          reader.readAsText(data);
          notice.hideLoading();
        } else {
          let urlName = url.substring(url.lastIndexOf('/') + 1);
          // 不存在后缀名置空
          if (fileName && !fileName.includes('.')) {
            fileName = '';
          }
          if (fileName) {
            console.log(fileName)
            this.daochu(res, fileName);
          } else if (urlName.includes('.')) {
            this.daochu(res, urlName);
          } else {
            this.daochu(res);
          }
        }
      })
      .catch(e => {
        notice.hideLoading();
        console.log(e);
      });
  },
  daochu(res, fileName) {
    try {
      if (!fileName) {
        if (res.headers['content-disposition']) {
          fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
        } else {
          fileName = '文件';
        }
      }
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
      notice.hideLoading();
    } catch (error) {
      console.log(error);
      notice.hideLoading();
    }
  },
  // 下载二维码
  dataToBlob(name, data) {
    data = data.split(',')[1];
    data = window.atob(data);
    var ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i);
    }
    var blob = new Blob([ia], {
      type: 'image/jpeg'
    });
    const href = window.URL.createObjectURL(blob);
    const downloadElement = document.createElement('a');
    downloadElement.href = href;
    downloadElement.download = name + '.jpg'; // 下载后的文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 下载
    document.body.removeChild(downloadElement); // 下载完成 移除 a
    window.URL.revokeObjectURL(href); // 释放blob对象
    // var fd = new FormData();
    // fd.append('img', blob,'.png');
    // this.upload(fd)
  },
  formRule: {
    arrRequired(msg = '请输入', trigger = 'change') {
      return {
        required: true,
        message: msg,
        trigger,
        validator(rule, value) {
          if (!value || !value.length) {
            return false;
          }
          return true;
        }
      };
    },
    objRequired(msg = '请输入') {
      return {
        required: true,
        message: msg,
        trigger: 'blur',
        validator(rule, value) {
          if (!value) {
            return false;
          }
          return true;
        }
      };
    },
    /**
     * type类型
      string: 必须是类型string。
      number: 必须是类型number。
      boolean: 必须是类型boolean。
      method: 必须是类型function。
      regexp: 必须是RegExp创建新的时不产生异常的实例或字符串RegExp。 pattern: /^[a-z]+$/,
      integer: 必须是类型number和整数。
      float: 必须是类型number和浮点数。
      array: 必须是由 确定的数组Array.isArray。
      object: 必须是 typeobject而不是Array.isArray。
      enum: 值必须存在于enum.
      date：值必须是有效的，由Date
      url: 必须是类型url。
      hex: 必须是类型hex。
      email: 必须是类型email。
      any: 可以是任何类型。
      height：正整数
      money：支持9位正整数，保留两位点后小数
     */
    required(msg = '请输入', trigger = 'change', type = 'string') {
      return { required: true, message: msg, type: type, trigger: trigger };
    },
    bankCard(msg = '请输入正确的银行卡', required = true) {
      return {
        required: required,
        pattern: /^([1-9]{1})(\d{14,18})$/,
        message: msg,
        trigger: 'blur'
      };
    },
    str(msg = '请输入数字或字母或汉字', required = true) {
      return {
        required: required,
        pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
        message: msg,
        trigger: 'change'
      };
    },
    str2(msg = '请输入数字或字母', required = true) {
      return {
        required: required,
        pattern: /^[a-zA-Z0-9]+$/,
        message: msg,
        trigger: 'change'
      };
    },
    tel(msg = '请输入正确的手机号', required = true) {
      return {
        required: required,
        pattern: /^1[1023456789]\d{9}$/,
        message: msg,
        trigger: 'change'
      };
    },
    idCard(msg = '请输入正确的身份证号', required = true) {
      return {
        required: required,
        pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: msg,
        trigger: 'change'
      };
    },
    email(required = true, msg = '请输入正确的邮箱地址') {
      return {
        required: required,
        pattern: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
        message: msg,
        trigger: 'change'
      };
    },
    height(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
        message: msg,
        trigger: 'blur'
      };
    },
    money(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /(^[0-9]{1,9}$)|(^[0-9]{1,9}[\.]{1}[0-9]{1,2}$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    weight(required = true, msg = '请输入') {
      return {
        required: required,
        pattern: /(^[0-9]{1,3}$)|(^[0-9]{1,3}[\.]{1}[0-9]{1,2}$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    num(msg = '请输入正确的数字', required = true) {
      return {
        required: required,
        message: msg,
        trigger: 'change',
        validator(rule, value) {
          if (required && !value && value !== 0) {
            return false;
          }
          if (value && isNaN(value)) {
            return false;
          }
          return true;
        }
      };
    },
    url(required = false, msg = '请输入正确的链接地址') {
      return {
        required: required,
        pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
        message: msg,
        trigger: 'blur'
      };
    },
    url2(msg = '请输入正确的链接地址') {
      return {
        pattern: /(http|https|fqtd):\/\/([\w.]+\/?)\S*/,
        message: msg,
        trigger: 'blur'
      };
    },
    number(required = true) {
      return {
        required: required,
        type: 'number',
        message: '请输入数字类型',
        trigger: 'blur',
        transform(value) {
          if (value === '' || value === undefined) {
            return value;
          } else {
            return Number(value);
          }
        }
      };
    },
    number100(required = true) {
      return {
        required: required,
        message: '请输入1-100的整数',
        trigger: 'blur',
        validator(rule, value) {
          if (isNaN(value) || !/^(\d|[1-9]\d|100)$/.test(value)) {
            return false;
          }
          if (value * 1 < 1 || value * 1 > 100) {
            return false;
          }
          return true;
        }
      };
    },
    justIntSort(msg = '请输入0或正整数') {
      return {
        pattern: /^([1-9]\d*|[0]{1,1})$/,
        message: msg,
        trigger: 'change'
      };
    },
    IntSort(msg = '请输入正整数') {
      return {
        pattern: /^[1-9]\d*$/,
        message: msg,
        trigger: 'blur'
      };
    },
    positiveNumber(msg = '请填写0或正数') {
      return {
        pattern: /^\d+(\.\d+)?$/,
        message: msg,
        trigger: 'blur'
      };
    },
    positiveNumberNozero(msg = '该数据必须为正数(不包括0)！') {
      return {
        pattern: /^0{1}(\.\d*)|(^[1-9][0-9]*)+(\.\d*)?$/,
        message: msg,
        trigger: 'blur'
      };
    },
    phone(msg = '请输入正确格式的手机号') {
      return {
        pattern: /^[1][0-9][0-9]{9}$/,
        message: msg,
        trigger: 'blur'
      };
    },
    IDNumber(msg = '请输入正确的身份证号') {
      return {
        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: msg,
        trigger: 'blur'
      };
    },
    strLength(msg = '请输入正确的位数', length) {
      return {
        required: true,
        message: msg,
        trigger: 'change',
        validator(rule, value) {
          if (value.length != length) {
            return false;
          }
          return true;
        }
      };
    }
  },
  //路由切换更新左侧导航
  togglePage() {
    if (this.$route && (this.$route.meta || this.$route.meta.title != '首页')) {
      this.$nextTick(() => {
        const arr = this.$route.matched
          .filter(item => item.meta.title)
          .map(item => {
            if (item.meta.title != '首页') {
              return {
                name: item.meta.title,
                path: item.path
              };
            }
          })
          .filter(item => item);
        window.parent.postMessage({ updateNav: arr, appMessage: true }, '*');
      });
    }
  },
  // 阿拉伯数字转汉字
  numberTransform(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
    if (!num || isNaN(num)) return '零';
    var english = num.toString().split('');
    var result = '';
    for (var i = 0; i < english.length; i++) {
      var des_i = english.length - 1 - i; // 倒序排列设值
      result = arr2[i] + result;
      var arr1_index = english[des_i];
      result = arr1[arr1_index] + result;
    }
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十'); // 将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零+/g, '零'); // 合并中间多个零为一个零
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万'); // 将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/亿万/g, '亿'); // 将【亿万】换成【亿】
    result = result.replace(/零+$/, ''); // 移除末尾的零
    result = result.replace(/^一十/g, '十'); // 将【一十】换成【十】
    return result;
  },
  // 时间处理
  formatDate(date, fmt = 'yyyy-MM-dd') {
    if (!date) {
      return '';
    }
    if (typeof date == 'string') {
      date = date.replace(/-/g, '-');
    }
    date = new Date(date);
    var o = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      'S': date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  },
  /**
   * 复制链接文本到剪切板
   * @param {*} url 需要复制的链接或者文本
   * @param {*} convert 是否转短连接
   */
  async copyUrl(url, convert, showAlert = true) {
    if (convert) {
      const res = await http({
        url: '/buz/orderImport/transformLongUrl',
        type: 'PUT',
        data: { url }
      });
      url = res.data;
    }
    const cInput = document.createElement('input');
    cInput.value = url;
    document.body.appendChild(cInput);
    // 选取文本域内容;
    cInput.select();
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    // Input要在正常的编辑状态下原生复制方法才会生效
    document.execCommand('Copy');
    /// 复制成功后再将构造的标签 移除
    cInput.remove();

    showAlert && notice.success('复制成功');
  },
  // 处理import selectTree from "@/components/commons/selectTree 树接收的数据结构
  dealTree(arr, parentNodeLabel, maxLevel = 2) {
    return arr.map(item => ({
      ...item,
      expand: item.nodeKey === 0 ? true : false,
      value: item.code,
      label: item.name,
      selected: false,
      parentNodeLabel: parentNodeLabel,
      expand: false,
      children: item.children && item.children.length > 0 && item.level < maxLevel ? this.dealTree(item.children, item.name, maxLevel) : []
    }));
  },
  downloadFun(item, name = '下载的文件') {
    http({
      url: '/buz/agreementInfo/download',
      type: 'GET',
      responseType: 'blob',
      data: {
        name: name,
        path: item.url
      }
    }).then(res => {
      const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    });
  },

  //统计功能次数
  getHealthTest(apiPermissionCode = '') {
    return new Promise((resolve, reject) => {
      http({
        url: '/buz/health-test',
        type: 'GET',
        data: {},
        hideAlert: true,
        apiPermissionCode
      })
        .then(res => {
          resolve();
        })
        .catch(() => {
          resolve();
        });
    });
  },
  /**
   * 处理每个页面功能点权限
   * @param {*} code 对应功能点按钮的code
   */
  pointAction(code) {
    let list = JSON.parse(localStorage.getItem('ACTION_BUTTON_TOKEN'));
    let value = null;
    list.forEach(item => {
      if (code == item.sign) {
        if (item.isExist == 1) {
          value = true;
        }
      }
    });
    return value;
  },
  /*
   * 监管报备
   */
  superviseShowVal() {
    let supervise = JSON.parse(localStorage.getItem('userInfo')).supervise;
    if (supervise == 1) {
      return false;
    } else {
      return true;
    }
  },

  /**
   *
   * @param {string} url
   * @returns 长链接转码
   */
  transUrl(url) {
    return new Promise((resolve, reject) => {
      http({
        url: '/buz/tools/transformLongUrl',
        type: 'PUT',
        data: {
          url
        }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  $httpRequestList: [],
  // 取消当前所有请求
  cancelhttpRequest() {
    this.$httpRequestList.forEach(c => {
      c('取消请求');
    });
    this.$httpRequestList = [];
  },
  // 删除fixed模式的图片预览
  delTableFixedPreview() {
    window.setTimeout(() => {
      const imgs = document.querySelectorAll('.ivu-table-fixed-right img');
      for (let index = 0; index < imgs.length; index++) {
        const element = imgs[index];
        element.removeAttribute('preview');
      }
    }, 100);
  },
  // 订单保单页、费用配置供应商显示控制
  showSupplier(){
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 配置隐藏供应商或者是监管模式
    if(userInfo.needHiddenSupplierInfo || userInfo.supervise == 1) {
      return false;
    }
    return true;
  },
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  //长沙精英保险代理
  isCSJY() {
    return this.userInfo.merchantNo == '202355000000800';
  },
  //鑫路鸿商户
  isXLH() {
    return this.userInfo.merchantNo == '203258000000800' || this.userInfo.merchantNo == 'XINHONG001';
  },
  // ok保
  isOkBao(){
    return this.userInfo.merchantNo == '260580000000800';
  }, 
  // ok团保
  isOkTX(){
    return this.userInfo.merchantNo == 'txokb';
  },
  // 如意保保
  isRYBB(){
    return this.userInfo.merchantNo == 'ryggcm';
  },
  //新泰和商户
  isXTH(){
    return this.userInfo.merchantNo == '204004000000800';
  },
  // 是否是梧桐树商户
  isWTS(){
    return this.userInfo.merchantNo == '260580000000800-wh';
  }, 

};

export default units;

//加法
Number.prototype.add = function(arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (this.mul(m) + Number(arg).mul(m)) / m;
};
//减法
Number.prototype.sub = function(arg) {
  return this.add(-arg);
};
//乘法
Number.prototype.mul = function(arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};
//除法
Number.prototype.div = function(arg) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = this.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg.toString().split('.')[1].length;
  } catch (e) {}
  var len = Math.max(t1, t2);
  r1 = this * Math.pow(10, len);
  r2 = arg * Math.pow(10, len);
  return r1 / r2;
};
